import { DeleteAllStore, GetUser } from '../helper/local-store';
import Modal from './modal';

type Props = {
  state: boolean;
  isNetWorkError: boolean;
  isConflictSession?: boolean;
};

export default function ModalError({
  state,
  isNetWorkError,
  isConflictSession = false,
}: Props) {
  let isEnglish = false;
  try {
    const user = GetUser();
    if (user !== null) {
      isEnglish = user.language === 'english';
    }
  } catch {
    isEnglish = false;
  }

  let header;
  let description;
  if (isEnglish) {
    if (isNetWorkError) {
      header = 'Network Error';
      description =
        "It seems like there's a problem connecting to the network. Please check your internet connection or try again.";
    } else if (isConflictSession) {
      header = 'Session Conflict';
      description = 'Your account has been detected log in on another device.';
    } else {
      header = 'Server Error';
      description = 'Some parts of the server are fail. Please try again.';
    }
  } else {
    if (isNetWorkError) {
      header = 'Kesalahan Jaringan';
      description =
        'Sepertinya ada masalah dengan koneksi jaringan Anda. Silakan periksa koneksi internet atau coba lagi.';
    } else if (isConflictSession) {
      header = 'Sesi Bentrok';
      description = 'Akun Anda telah terdeteksi login di device lain.';
    } else {
      header = 'Kesalahan Server';
      description =
        'Terdapat kesalahan pada beberapa bagian server. Silakan coba lagi.';
    }
  }

  return (
    <Modal
      modalState={state}
      handleCloseModal={() => {
        if (isConflictSession) {
          DeleteAllStore();
          window.location.href = '/logout';
        } else {
          window.location.reload();
        }
      }}
      header={
        <>
          <span className="mr-2">
            <i
              className={
                isNetWorkError
                  ? 'fa fa-exclamation-triangle'
                  : 'fa fa-exclamation-circle'
              }
            ></i>
          </span>
          <span className="text-white">{header}</span>
        </>
      }
      headerColor={isNetWorkError ? 'bg-yellow-500' : 'bg-red-500'}
      zIndex={'z-[999]'}
      size="lg"
      closeText={isConflictSession ? 'logout' : 'Retry'}
      closeColor="error"
      closeIcon={isConflictSession ? 'fa fa-sign-out' : 'fa fa-refresh'}
    >
      <div>{description}</div>
    </Modal>
  );
}
